export enum LogAction {
    Copy = 'copy',
    Create = 'create',
    CreateUpdate = 'create/update',
    Delete = 'delete',
    Execute = 'execute',
    Update = 'update',

    Unknown = 'unknown'
}
